import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, ChevronRight } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 pt-12 pb-24 text-gray-600 mt-12">
      <div className="max-w-7xl mx-auto px-4">
        {/* Newsletter / Top Section */}
        <div className="mb-12 border-b border-gray-100 pb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Join our newsletter</h3>
            <p className="text-sm text-gray-500 mb-4">Get the latest updates on new products and upcoming sales.</p>
            <div className="flex gap-2 max-w-md">
                <input type="email" placeholder="Enter your email" className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:border-black outline-none" />
                <button className="bg-black text-white px-6 py-2 rounded-lg font-bold hover:bg-gray-800">Subscribe</button>
            </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4 uppercase tracking-wider text-sm">Get In Touch</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 group cursor-pointer">
                <div className="p-2 bg-gray-100 rounded-full group-hover:bg-black group-hover:text-white transition-colors">
                    <Phone size={16} />
                </div>
                <div>
                    <span className="block font-bold text-gray-900">Call Us</span>
                    <span className="text-gray-500 hover:text-black transition-colors">+92 318 0508608</span>
                </div>
              </li>
              <li className="flex items-start gap-3 group cursor-pointer">
                <div className="p-2 bg-gray-100 rounded-full group-hover:bg-black group-hover:text-white transition-colors">
                    <Mail size={16} />
                </div>
                <div>
                    <span className="block font-bold text-gray-900">Email Us</span>
                    <span className="text-gray-500 hover:text-black transition-colors">cs@shoebhai.pk</span>
                </div>
              </li>
              <li className="flex items-start gap-3 group cursor-pointer">
                <div className="p-2 bg-gray-100 rounded-full group-hover:bg-black group-hover:text-white transition-colors">
                    <MapPin size={16} />
                </div>
                <div>
                    <span className="block font-bold text-gray-900">Location</span>
                    <span className="text-gray-500">Karachi, Pakistan</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4 uppercase tracking-wider text-sm">Customer Service</h3>
            <ul className="space-y-2 text-sm">
              {['Track Your Order', 'Shipping Policy', 'Returns & Exchange', 'Terms & Conditions', 'Size Guide'].map((link) => (
                  <li key={link}>
                      <a href="#" className="flex items-center gap-2 hover:text-black hover:translate-x-1 transition-all">
                          <ChevronRight size={14} className="text-gray-400" />
                          {link}
                      </a>
                  </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4 uppercase tracking-wider text-sm">The Company</h3>
            <ul className="space-y-2 text-sm">
              {['About Us', 'Privacy Policy', 'Contact Us', 'Careers', 'Store Locations'].map((link) => (
                  <li key={link}>
                      <a href="#" className="flex items-center gap-2 hover:text-black hover:translate-x-1 transition-all">
                          <ChevronRight size={14} className="text-gray-400" />
                          {link}
                      </a>
                  </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4 uppercase tracking-wider text-sm">Follow Us</h3>
            <p className="text-sm text-gray-500 mb-4">Stay connected with us on social media for updates and exclusive offers.</p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600 hover:bg-[#1877F2] hover:text-white transition-all transform hover:-translate-y-1 shadow-sm hover:shadow-md"><Facebook size={20} /></a>
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600 hover:bg-[#E4405F] hover:text-white transition-all transform hover:-translate-y-1 shadow-sm hover:shadow-md"><Instagram size={20} /></a>
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600 hover:bg-[#1DA1F2] hover:text-white transition-all transform hover:-translate-y-1 shadow-sm hover:shadow-md"><Twitter size={20} /></a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400">
          <p>&copy; {new Date().getFullYear()} Shoebhai. All rights reserved.</p>
          <div className="flex gap-4">
              <span>Privacy</span>
              <span>Terms</span>
              <span>Sitemap</span>
          </div>
        </div>
      </div>
    </footer>
  );
};